import { useState } from "react";
import { Waves, Rocket, LogIn, Menu } from "lucide-react";
import { scrollTo } from "./LandingHelpers";

export default function LandingNavbar({ c, user, handleCTA, handleLogin, handleDashboard }) {
  const [mobileMenu, setMobileMenu] = useState(false);

  const NAV_LINKS = [
    { label: c.nav.howItWorks, id: "como-funciona" },
    { label: c.nav.features,   id: "recursos" },
    { label: c.nav.about,      id: "quem-somos" },
    { label: c.nav.pricing,    id: "pricing" },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100 shadow-sm" data-testid="landing-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between" style={{ height: "6rem" }}>
          <div className="flex items-center gap-2.5 cursor-pointer" onClick={() => window.scrollTo({top:0,behavior:"smooth"})}>
            <img src="/brand/logo-1.png" alt="Pipe4.me" style={{ height: "4.5rem" }} className="object-contain" />
          </div>

          <div className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map(item => (
              <button key={item.id} onClick={() => scrollTo(item.id)}
                className="px-3 py-2 text-sm text-slate-600 hover:text-[#3B82F6] font-medium transition-colors rounded-lg hover:bg-blue-50">
                {item.label}
              </button>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2">
            <button onClick={user ? handleDashboard : handleLogin}
              className="flex items-center gap-1.5 px-4 py-2 text-slate-600 hover:text-slate-900 text-sm font-medium transition-colors border border-slate-200 rounded-lg hover:border-slate-300">
              <LogIn className="w-3.5 h-3.5" /> {user ? "Login" : c.nav.login}
            </button>
            <button onClick={handleCTA} data-testid="navbar-cta-btn"
              className="flex items-center gap-1.5 px-4 py-2 bg-[#3B82F6] text-white rounded-lg text-sm font-semibold hover:bg-blue-600 transition-all shadow-sm hover:shadow-blue-200 hover:shadow-md">
              <Rocket className="w-3.5 h-3.5" /> {c.nav.cta}
            </button>
          </div>

          <button onClick={() => setMobileMenu(!mobileMenu)} className="md:hidden p-2 rounded-lg hover:bg-slate-50">
            <Menu className="w-5 h-5 text-slate-600" />
          </button>
        </div>

        {mobileMenu && (
          <div className="md:hidden py-3 border-t border-slate-100 space-y-2 pb-4">
            {NAV_LINKS.map(item => (
              <button key={item.id} onClick={() => { scrollTo(item.id); setMobileMenu(false); }}
                className="block w-full text-left px-3 py-2 text-sm text-slate-600 hover:text-[#3B82F6] font-medium rounded-lg hover:bg-blue-50 transition-colors">
                {item.label}
              </button>
            ))}
            <div className="flex gap-2">
              <button onClick={handleLogin}
                className="flex-1 flex items-center justify-center gap-1.5 px-4 py-2.5 border border-slate-200 text-slate-700 rounded-lg text-sm font-medium">
                <LogIn className="w-3.5 h-3.5" /> {c.nav.login}
              </button>
              <button onClick={handleCTA}
                className="flex-1 flex items-center justify-center gap-1.5 px-4 py-2.5 bg-[#3B82F6] text-white rounded-lg text-sm font-semibold">
                <Rocket className="w-3.5 h-3.5" /> {c.nav.cta}
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
